import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PatientService } from 'src/app/basic-data/services/patient.service';
import { PatientExamsService } from 'src/app/sas/services/patient-exams.service';
import { StagesEnum } from 'src/app/shared/models/system/Stages.enum';
import { StagesDiagnosesEnum } from 'src/app/shared/models/system/StagesDiagnoses.enum';
import { Globals } from 'src/app/shared/services/globals';
import { StagesService } from 'src/app/shared/services/stages.service';

@Component({
  selector: 'app-patient-menu',
  templateUrl: './patient-menu.component.html',
  styleUrls: ['./patient-menu.component.css']
})
export class PatientMenuComponent implements OnInit {

  constructor( public _PatientExamsService : PatientExamsService , private _StageService : StagesService,
     private toastr: ToastrService, private _PatientService : PatientService, public global: Globals) { }

  patientUserId:any;
  patient: any;
  patientCurrentStage: number;

  // takenExams:any = [];
  passedStages:any = [];

  IsCaseHisoryTaken:boolean = false;
  IsOasesTaken:boolean = false;
  IsSSRSTaken:boolean = false;
  IsSSI4Taken:boolean = false;
  IsBookingTaken:boolean = false;

  IsPreTreatmentTaken:boolean = false;

  IsTreatmentS1Taken:boolean = false;
  IsOasesTreStage1Taken:boolean = false;
  IsSSRSTreStage1Taken:boolean = false;
  IsSSI4TreStage1Taken:boolean = false;
  IsBookingTreStage1Taken:boolean = false;

  IsTreatmentS2Taken:boolean = false;
  IsOasesTreStage2Taken:boolean = false;
  IsSSRSTreStage2Taken:boolean = false;
  IsSSI4TreStage2Taken:boolean = false;
  IsBookingTreStage2Taken:boolean = false;

  IsOasesLastTaken:boolean = false;
  IsSSRSLastTaken:boolean = false;
  IsSSI4LastTaken:boolean = false;
  IsBookingLastTaken:boolean = false;

  allowedStages : number[];
  diagnosisIsPaid:boolean = false;
  treatmentIsPaid:boolean = false;

  ngOnInit(): void {

    this._PatientService.getPatientById(this.global.UserId).subscribe(
      (data:any) => {
        if(data.status !=-1){
          this.patient= data.data;
          console.log("in patient menu - patient",this.patient);
          this.patientCurrentStage= this.patient.currentStage;
        }
      },
      (error:any) =>{
        console.log("in patient menu - getPatientById service " + error);
      }
    );

    this._StageService.GetPatientStages(this.global.UserId).subscribe(
      (data:any) => {
        this.passedStages= data.data;
        console.log('in patient menu - Passed Stages :', this.passedStages);

        // Diagnosis Stage
        if ( this.passedStages.some(s => s.stageDiagnosesId == StagesDiagnosesEnum.MEDICAL_HISTORY) ){
          this.IsCaseHisoryTaken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.DIAGONSES && s.stageDiagnosesId == StagesDiagnosesEnum.OASES) ){
          this.IsOasesTaken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.DIAGONSES && s.stageDiagnosesId == StagesDiagnosesEnum.SSRS) ){
          this.IsSSRSTaken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.DIAGONSES && s.stageDiagnosesId == StagesDiagnosesEnum.SSI4) ){
          this.IsSSI4Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.DIAGONSES && s.stageDiagnosesId == StagesDiagnosesEnum.Booking) ){
          this.IsBookingTaken = true;
        }

        // Pre Treatment
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREAT_FIRST_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.Pre_Treatment) ){
          this.IsPreTreatmentTaken = true;
        }

        // Treatment Stage 1
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREAT_FIRST_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.Treatment_Session_12) ){
          this.IsTreatmentS1Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREAT_FIRST_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.OASES) ){
          this.IsOasesTreStage1Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREAT_FIRST_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.SSRS) ){
          this.IsSSRSTreStage1Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREAT_FIRST_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.SSI4) ){
          this.IsSSI4TreStage1Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREAT_FIRST_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.Booking) ){
          this.IsBookingTreStage1Taken = true;
        }

        // Treatment Stage 2
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREATMENT_SECOND_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.Treatment_Session_29) ){
          this.IsTreatmentS2Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREATMENT_SECOND_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.OASES) ){
          this.IsOasesTreStage2Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREATMENT_SECOND_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.SSRS) ){
          this.IsSSRSTreStage2Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREATMENT_SECOND_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.SSI4) ){
          this.IsSSI4TreStage2Taken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.TREATMENT_SECOND_STAGE && s.stageDiagnosesId == StagesDiagnosesEnum.Booking) ){
          this.IsBookingTreStage2Taken = true;
        }

        // Diagnosis Last
        if ( this.passedStages.some(s => s.stageId == StagesEnum.DIAGONSES_LAST && s.stageDiagnosesId == StagesDiagnosesEnum.OASES) ){
          this.IsOasesLastTaken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.DIAGONSES_LAST && s.stageDiagnosesId == StagesDiagnosesEnum.SSRS) ){
          this.IsSSRSLastTaken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.DIAGONSES_LAST && s.stageDiagnosesId == StagesDiagnosesEnum.SSI4) ){
          this.IsSSI4LastTaken = true;
        }
        if ( this.passedStages.some(s => s.stageId == StagesEnum.DIAGONSES_LAST && s.stageDiagnosesId == StagesDiagnosesEnum.Booking) ){
          this.IsBookingLastTaken = true;
        }

      },
      (error:any) =>{
        console.log("in patient menu - GetPatientStages service " + error);
      }
    );

    this._PatientService.GetPatientSubscriptionStages(this.global.UserId).subscribe(
      (data:any) => {
        if(data.status !=-1){
          this.allowedStages = data.data;
          console.log("allowed Stages : " + this.allowedStages);
          // مرحلة التشخيص قبل العلاج
          if(this.allowedStages.includes(StagesEnum.DIAGONSES)){
            this.diagnosisIsPaid = true;
          }
          // المرحلة العلاجية الاولى والثانية
          if(this.allowedStages.includes(StagesEnum.TREAT_FIRST_STAGE) && this.allowedStages.includes(StagesEnum.TREATMENT_SECOND_STAGE)){
            this.treatmentIsPaid = true;
          }
        }
      },
      (error:any) =>{
        console.log(error);
      });

    // this._PatientExamsService.GetTakenExams( this.global.UserId).subscribe(
    //   (data:any) => {
    //     this.takenExams = data.data;
    //     console.log('Taken Exams :', this.takenExams);

    //     if (this.takenExams.some(e => e.examCode == "ex_ph")){
    //       this.IsCaseHisoryTaken = true;
    //     }
    //     if (this.takenExams.some(e => e.examCode == "EX_OASES")){
    //       this.IsOasesTaken = true;
    //     }
    //     if (this.takenExams.some(e => e.examCode == "EX_SSRS")){
    //       this.IsSSRSTaken = true;
    //     }
    //     if (this.takenExams.some(e => e.examCode == "EX_SSI4")){
    //       this.IsSSI4Taken = true;
    //     }
    //   },
    //   (error) => {
    //     console.log("in patient menu - GetTakenExams service " + error);
    //   });

  }

}
